// extracted by mini-css-extract-plugin
export default {"base":"vp_q8QDo","box":"vp_ptMTb","shield":"vp_QzpDj","graphic":"vp_lNeX0","eyebrow":"vp_HngFn","title":"vp_GUiDM","subtitle":"vp_oEScM","actions":"vp_ifdEx"};